import { apiRequest, withToken } from './http-client';

export const projectCreate = async (token, data) => {
    return apiRequest({
        method: 'post',
        url: '/project/',
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getProject = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/project/',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const searchProject = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/project/search',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const getProjectById = async (token, projectId, params = {}) => {
    return apiRequest({
        method: 'get',
        url: `/project/${projectId}`,
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const updateProject = async (token, projectId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/project/${projectId}`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getProjectSchedule = async (token, projectId) => {
    return apiRequest({
        method: 'get',
        url: `/project/${projectId}/schedule`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const updateProjectSchedule = async (token, projectId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/project/${projectId}/schedule`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getProjectSla = async (token, projectId) => {
    return apiRequest({
        method: 'get',
        url: `/project/${projectId}/sla`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const updateProjectSla = async (token, projectId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/project/${projectId}/sla`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getProjectEscalations = async (token, projectId) => {
    return apiRequest({
        method: 'get',
        url: `/project/${projectId}/escalations`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const updateProjectEscalations = async (token, projectId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/project/${projectId}/escalations`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getProjectGroups = async (token, projectId) => {
    return apiRequest({
        method: 'get',
        url: `/project/${projectId}/groups`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const updateProjectGroups = async (token, projectId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/project/${projectId}/groups`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getProjectCustomFields = async (token, projectId, params = {}) => {
    return apiRequest({
        method: 'get',
        url: `/project/${projectId}/custom-fields`,
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const createProjectCustomField = async (token, projectId, data) => {
    return apiRequest({
        method: 'post',
        url: `/project/${projectId}/custom-fields`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const exportProjectCustomFieldGroup = async (token, projectId, groupId) => {
    return apiRequest({
        method: 'get',
        url: `/project/${projectId}/custom-fields/groups/${groupId}/export`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const importProjectCustomFieldGroup = async (token, projectId, data) => {
    return apiRequest({
        method: 'post',
        url: `/project/${projectId}/custom-fields/groups/import`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const updateProjectCustomField = async (token, projectId, customFieldId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/project/${projectId}/custom-fields/${customFieldId}`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const deleteProjectCustomField = async (token, projectId, customFieldId) => {
    return apiRequest({
        method: 'delete',
        url: `/project/${projectId}/custom-fields/${customFieldId}`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};
